import { Button, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'
import { Scope } from '../../../../../../../../enums/scope'
import { isAuthorized } from '../../../../../../../../utils/isAuthorized'
import { useVatDeclaration } from '../../../../../../context/vatDeclarationContext'
import { VatDeclarationStatus } from '../../../../../../enums/vatDeclarationStatus'
import { SubmitButtonVariant } from '../../../../../../utils/getSubmitButtonVariant'

interface SideActionsPrimaryButtonProps {
  buttonVariant?: SubmitButtonVariant | null
  onShowIntegrationForm?: (showForm: boolean) => void
}

export const SideActionsPrimaryButtonNL = ({
  buttonVariant,
  onShowIntegrationForm,
}: SideActionsPrimaryButtonProps): ReactElement | null => {
  const { t } = useTranslation()
  const { status } = useVatDeclaration()

  const { open: openRegisterPaymentModal } = useModal(ModalId.VatDeclarationsRegisterPeriodPaymentModal)
  const { open: openSettlementModal } = useModal(ModalId.VatDeclarationsSettlePeriodModal)

  const isVatSubmissionSendingAuthorized = isAuthorized(Scope.VatSubmissionSendingWrite)
  const shouldRenderPaymentButton =
    status === VatDeclarationStatus.ReadyToPay || status === VatDeclarationStatus.OverduePayment

  const handleSubmitVat = useCallback(() => {
    onShowIntegrationForm?.(true)
  }, [onShowIntegrationForm])

  const handleSubmitManually = useCallback(() => {
    openSettlementModal()
  }, [openSettlementModal])

  const handleRegisterPaymentButtonClick = useCallback(() => {
    openRegisterPaymentModal()
  }, [openRegisterPaymentModal])

  if (shouldRenderPaymentButton) {
    return <Button onClick={handleRegisterPaymentButtonClick}>{t('vat_declarations.actions.register_payment')}</Button>
  }

  if (buttonVariant === SubmitButtonVariant.Manual) {
    return (
      <Button variant="outlined" onClick={handleSubmitManually}>
        {t('vat_declarations.submit_manually')}
      </Button>
    )
  }

  if (buttonVariant === SubmitButtonVariant.Integration && isVatSubmissionSendingAuthorized) {
    return <Button onClick={handleSubmitVat}>{t('vat_declarations.submit_vat')}</Button>
  }

  return null
}
